// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__stackContainer___GsW_Z {
    display: flex;
    flex-direction: row;
    margin-bottom: 2vh;
}

.style__stackItem___WYVAC {
    display: flex;
    justify-content: center;
    align-items: center;
}

.style__stackItemTitle___qLeDb {
    font-size: 20px;
    transition: background-color 0.3s ease;
    padding: 0.5vw;
    border-radius: 10px;
}

.style__stackItemTitle___qLeDb:hover {
    background-color: var(--hover-color);
}


.style__input___oIVvV {
    border: none;
    outline: none;
    font-size: 20px;
    height: 75vh;
    margin-top: 4vh;
    width: 100%;
}

.style__button___mrtAQ {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5vw;
    font-size: 15px;
    border-radius: 40px;
    height: 32px;
    margin: auto;
    border: 1px solid var(--black);
    margin-bottom: 16px;
    text-align: center;
    color: var(--black);
    align-self: flex-start;
}


.style__parsedText___Ve8Vd {
    white-space: pre-line;
}
`, "",{"version":3,"sources":["webpack://./src/client/CreateNoteScreen/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;;AAGA;IACI,qBAAqB;AACzB","sourcesContent":[".stackContainer {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 2vh;\n}\n\n.stackItem {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.stackItemTitle {\n    font-size: 20px;\n    transition: background-color 0.3s ease;\n    padding: 0.5vw;\n    border-radius: 10px;\n}\n\n.stackItemTitle:hover {\n    background-color: var(--hover-color);\n}\n\n\n.input {\n    border: none;\n    outline: none;\n    font-size: 20px;\n    height: 75vh;\n    margin-top: 4vh;\n    width: 100%;\n}\n\n.button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 5vw;\n    font-size: 15px;\n    border-radius: 40px;\n    height: 32px;\n    margin: auto;\n    border: 1px solid var(--black);\n    margin-bottom: 16px;\n    text-align: center;\n    color: var(--black);\n    align-self: flex-start;\n}\n\n\n.parsedText {\n    white-space: pre-line;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stackContainer": `style__stackContainer___GsW_Z`,
	"stackItem": `style__stackItem___WYVAC`,
	"stackItemTitle": `style__stackItemTitle___qLeDb`,
	"input": `style__input___oIVvV`,
	"button": `style__button___mrtAQ`,
	"parsedText": `style__parsedText___Ve8Vd`
};
export default ___CSS_LOADER_EXPORT___;
